"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.PortalConsumer = exports.PortalProvider = exports.PortalProviderContext = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _jsxRuntime = require("react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var PortalProviderContext = /*#__PURE__*/React.createContext({});
exports.PortalProviderContext = PortalProviderContext;

var PortalProvider = function PortalProvider(_ref) {
  var children = _ref.children,
      value = (0, _objectWithoutProperties2.default)(_ref, ["children"]);
  var store = value.store;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(PortalProviderContext.Provider, {
    value: value,
    children: store ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRedux.Provider, {
      store: store,
      children: children
    }) : children
  });
};

exports.PortalProvider = PortalProvider;

var PortalConsumer = function PortalConsumer(_ref2) {
  var children = _ref2.children;
  var context = (0, React.useContext)(PortalProviderContext);
  return children(context);
};

exports.PortalConsumer = PortalConsumer;